import { render } from "./company-achievement-details.vue?vue&type=template&id=41cce479&scoped=true"
import script from "./company-achievement-details.vue?vue&type=script&lang=js"
export * from "./company-achievement-details.vue?vue&type=script&lang=js"

import "./company-achievement-details.vue?vue&type=style&index=0&id=41cce479&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cce479"]])

export default __exports__